<template>
  <div>
    <div class="">
      <v-card class= "person">
        <div>
          <app-row icon="user" title="نام:" :value="person.FName3" />
          <app-row icon="building" title="سمت:" :value="person.N_Chart" />

          <app-row icon="phone" title="تلفن:" :value="person.Telphone" />
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["person"],
  components: {
    appRow: DetailRow,
  },
};
</script>
<style scoped>
.person {
  background-color: lemonchiffon;
}
</style>>

